import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import ModalGenericPostCancelContainer from "../../../Common/ModalGenericPostCancelContainer";

import { deleteIleggelseMakulering as deleteIleggelseMakuleringAction } from "../../../../actions/ileggelseMakuleringerActions";
import { getIleggelse as getIleggelseAction } from "../../../../actions/ileggelserActions";

import { getMostRecentObjectComparedOnParameter } from "../../../../utils/date";

export default function OpphevMakuleringContainer() {
  const ileggelse = useSelector((state) => state.ileggelse);
  const mostRecentMakulering = useSelector(
    (state) =>
      state.ileggelseMakuleringer &&
      getMostRecentObjectComparedOnParameter(
        state.ileggelseMakuleringer,
        "makuleringDato",
      ),
  );
  const dispatch = useDispatch();

  const deleteIleggelseMakulering = (id) =>
    dispatch(deleteIleggelseMakuleringAction(id));
  const getIleggelse = (id) => dispatch(getIleggelseAction(id));

  const handleApiCall = async (ileggelseMakuleringId) => {
    return deleteIleggelseMakulering(ileggelseMakuleringId)
      .then(() => {
        getIleggelse(ileggelse.id);
        return Promise.resolve();
      })
      .catch((error) => Promise.reject(error));
  };

  const showOpphevMakulering = () => {
    if (!ileggelse.isMakulert) return false;
    if (!mostRecentMakulering) return false;
    if (ileggelse.id !== mostRecentMakulering.ileggelseId) return false;
    return true;
  };

  if (showOpphevMakulering()) {
    return (
      <ModalGenericPostCancelContainer
        id={mostRecentMakulering.id}
        submitButtonText="Opphev makulering"
        submittingButtonText="Opphever makulering..."
        successPostCallFlashMessage="Endring vellykket"
        errorPostCallFlashMessage="Endring feilet"
        handleApiCall={handleApiCall}
        modalTitle={`Opphev makulering for ileggelse  ${ileggelse.ileggelsesnummer}`}
        openModalComponentFunction={(props) => (
          <Button
            className="btn btn-bym-standard"
            style={{ marginLeft: 20 }}
            onClick={props.openModal}
          >
            Opphev makulering
          </Button>
        )}
      >
        <p>{`Vil du oppheve makulering av ileggelse ${ileggelse.ileggelsesnummer}?`}</p>
      </ModalGenericPostCancelContainer>
    );
  }
  return <span />;
}
